// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: grid;
  grid-template-columns: 17% 78%;
  gap: 3%;
  height: 100vh;
  background-color: whitesmoke;
}

/* For stepper Function */
.StepperContainer-0-2-1 {
  display: flex;
  padding-top: 24px !important;
  padding-bottom: 10px !important;
  align-items: flex-start;
  flex-direction: row;
}

body,
html {
  color: black !important;
  font-size: 1rem !important;
  font-family: Helvetica !important;
}

/* For stepper Function */
.airflow {
  display: grid;
  grid-template-columns: 40% 40%;
  align-items: start;
  justify-content: center;
  gap: 5%;
  width: 100%;
}

.airflowfields {
  margin-top: 30px;
  display: grid;
  grid-row-gap: 20px;
  padding: 10px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EAEA,8BAAA;EACA,OAAA;EACA,aAAA;EACA,4BAAA;AADF;;AAcA,yBAAA;AACA;EACE,aAAA;EACA,4BAAA;EACA,+BAAA;EACA,uBAAA;EAEA,mBAAA;AAZF;;AAeA;;EAEE,uBAAA;EACA,0BAAA;EACA,iCAAA;AAZF;;AAeA,yBAAA;AAWA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;EACA,OAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAtBF","sourcesContent":["@import \"./styles/sass/common.scss\";\n.App {\n  display: grid;\n  // flex-direction: row;\n  grid-template-columns: 17% 78%;\n  gap: 3%;\n  height: 100vh;\n  background-color: whitesmoke;\n}\n\n// .mainContent {\n//   // align-items: center;\n//   overflow: scroll;\n//   // flex-direction: column;\n//   // align-items: center;\n//   // width: 1100px !important;\n//   // justify-content: center;\n//   // padding-bottom: 20px;\n// }\n\n/* For stepper Function */\n.StepperContainer-0-2-1 {\n  display: flex;\n  padding-top: 24px !important;\n  padding-bottom: 10px !important;\n  align-items: flex-start;\n  // font-family: $fontStyle !important;\n  flex-direction: row;\n}\n\nbody,\nhtml {\n  color: black !important;\n  font-size: 1rem !important;\n  font-family: Helvetica !important;\n}\n\n/* For stepper Function */\n// @media only screen and (max-width: 768px) {\n//   .App {\n//     grid-template-columns: 0% 85%;\n//     justify-content: center;\n//   }\n//   .formDetails {\n//     width: 100%;\n//   }\n// }\n\n.airflow {\n  display: grid;\n  grid-template-columns: 40% 40%;\n  align-items: start;\n  justify-content: center;\n  gap: 5%;\n  width: 100%;\n}\n\n.airflowfields {\n  margin-top: 30px;\n  display: grid;\n  grid-row-gap: 20px;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n// input:-webkit-autofill,\n// input:-webkit-autofill:hover,\n// input:-webkit-autofill:focus,\n// input:-webkit-autofill:active {\n//   -webkit-background-clip: text;\n//   -webkit-text-fill-color: black;\n//   transition: background-color 5000s ease-in-out 0s;\n//   box-shadow: inset 0 0 20px 20px #23232329;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
